<template>
  <div class="az_panel clearfix">
    <div class="az-lft lft-block">
      <slot name="lft"></slot>
    </div>
    <div class="az-rt rt-block">
      <slot name="rt"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'az-panel'
};
</script>

<style lang="scss" scoped>
.az_panel {
  padding-bottom: 16px;
  .lft-block > div,
  .lft-block > button {
    float: left;
    margin-right: 8px;
    margin-left: 0;
  }

  .rt-block > div,
  .rt-block > button {
    float: left;
    margin-left: 8px;
    margin-right: 0;
  }

  .rt-block > .block {
    line-height: 36px;
    margin-left: 10px;
  }

  .rt-block > .split-line {
    width: 1px;
    height: 24px;
    margin-top: 6px;
    background-color: $border-color-dark;
    margin-left: 8px;
  }

  .title {
    display: inline-block;
    padding-left: 10px;
    padding-right: 10px;
  }

  .cross_line {
    display: inline-block;
    height: 20px;
    width: 1px;
    padding: 0 15px;
    position: relative;

    &::after {
      content: "";
      width: 1px;
      height: 20px;
      background-color: #d4d4d4;
      position: absolute;
      left: 50%;
      top: 20%;
      z-index: 1;
    }
  }
}
</style>